module.exports = __webpack_public_path__ + "static/media/DailyProductionIcon.8f05e74a.svg";